import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const attendance = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getEmployeeScheduleAPI(values) {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const query = JSON.stringify(values);
        const res = await fetch(
            `${config.host}/panel/attendance?query=${query}`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

     async function getTodaysAttendanceAPI() {
      try {
        const obj = {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        };
        // const query = JSON.stringify(values);
        const res = await fetch(
           `${config.host}/panel/attendance/today`,
          obj
        );
        return handleResponse(res);
      } catch (err) {
        handleError(err);
      }
    }

  return {
    getEmployeeScheduleAPI,
    getTodaysAttendanceAPI,
  }

}

export default attendance;